module.exports = __webpack_public_path__ + "media/images/ai_voice_samples/sid-a2580ef8e430a5d90405dcf3e5db3f8c.mp3";